import {InvoiceService} from '@/common/api/invoice.service'
import {
    INVOICE_CREATE,
    INVOICE_EDIT,
    INVOICE_DELETE,
    INVOICE_GET,
    INVOICES_GET,
    INVOICES_BM_GET,
    INVOICE_ACTIVE,
    INVOICE_INACTIVE,
    INVOICE_SEARCH, INVOICES_SIMPLE_BM_GET, 
} from './actions/invoice.type.js'
import {
    SET_INVOICE,
    SET_INVOICES,
    SET_INVOICE_PAGINATION,
    SET_INVOICE_ACTIVE,
    INVOICE_RESET,
    INVOICE_RESET_STATE, SET_INVOICES_SIMPLE,
} from './mutations/invoice.type.js'

import {CHANGE_PROGRESS} from './mutations/mutations.type.js'

const initialState = () => {
    return {
        invoice: {
            id: 0,
            active: false,
            name: "",
            desc: "",
            value: null,
            categoryID: 0,
            categoryName: "",

        },

        invoicePagination: {
            startDate:null,
            endDate:null,
            search: "",
            account: null,
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },

        itemsPerPage: 10,
        invoices: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            credito: 0,
            debito:0,
            startDate:"",
            endDate:"",
            items: []
        },
        invoicesSimple: [],
        categories: [],

    }
}

export const state = initialState()

const getters = {
    invoice: state => {
        return state.invoice
    },
    invoices: state => {
        return state.invoices
    },
    invoicesSimple: state => {
        return state.invoicesSimple
    },
    invoicePagination: state => {
        return state.invoicePagination
    },
    categories: state => {
        return state.categories
    }
}

export const mutations = {
    [SET_INVOICE](state, data) {
        state.invoice = data
    },
    [SET_INVOICES](state, data) {
        state.invoices = data
    },
    [SET_INVOICES_SIMPLE](state, data) {
        state.invoicesSimple = data
    },

    // [SET_CATEGORIES](state, data) {
    //     state.categories = data
    // },
    [SET_INVOICE_PAGINATION](state, data) {
        state.invoices.activePage = data.page
        state.invoicePagination.itemsPerPage = data.itemsPerPage
        state.invoicePagination.orderBy = data.orderBy
        state.invoicePagination.sortDesc = data.sortDesc
        state.invoicePagination.endDate = data.endDate
        state.invoicePagination.startDate = data.startDate
    },
    [SET_INVOICE_ACTIVE](state, active) {
        state.invoice.active = active
    },
    [INVOICE_RESET](state) {
        Object.assign(state.invoice, initialState().invoice)
    },
    [INVOICE_RESET_STATE](state) {
        Object.assign(state, initialState())
    },
}

export const actions = {
    async [INVOICES_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await InvoiceService.list()
        commit(SET_INVOICES_SIMPLE, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [INVOICES_SIMPLE_BM_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await InvoiceService.listBM(id)
        commit(SET_INVOICES_SIMPLE, data)
        commit(CHANGE_PROGRESS, false)
    },

    async [INVOICE_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await InvoiceService.get(id)
        commit(SET_INVOICE, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [INVOICES_BM_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await InvoiceService.bmServices(id)
        commit(SET_INVOICES_SIMPLE, data)
        commit(CHANGE_PROGRESS, false)
    },

    async [INVOICE_SEARCH]({commit, state}) {
        let accountType = ""
        let account = 0
        if ( state.invoicePagination.account != null) {
            accountType = state.invoicePagination.account.accountCategory.charAt(0)
            account = state.invoicePagination.account.id
        }
        commit(CHANGE_PROGRESS, true)
        const {data} = await InvoiceService.search(
            state.invoices.activePage,
            state.invoicePagination.itemsPerPage,
            accountType,
            account,
            state.invoicePagination.search,
            state.invoicePagination.orderBy,
            state.invoicePagination.sortDesc,
            state.invoicePagination.startDate,
            state.invoicePagination.endDate)
        commit(SET_INVOICES, data)
        commit(CHANGE_PROGRESS, false)
    },
    [INVOICE_CREATE]({state}) {
        return InvoiceService.create(state.invoice)
    },
    [INVOICE_EDIT]({state}) {
        return InvoiceService.update("", state.invoice)
    },
    [INVOICE_ACTIVE](_, id) {
        return InvoiceService.active(id)
    },
    [INVOICE_INACTIVE](_, id) {
        return InvoiceService.inactive(id)
    },
    [INVOICE_DELETE]({state}) {
        return InvoiceService.delete(state.invoice.id)
    },
    [INVOICE_RESET_STATE]({commit}) {
        commit(INVOICE_RESET_STATE)
    }
}
export default {
    state,
    actions,
    mutations,
    getters
}
